import { memo } from 'react';

import NumericIcon from '@/assets/field-type-numeric.svg?react';
import { merge } from '@/components';
import { FormatterValidatorLogo, VariantLogoProps } from '@/components/logos';

export type NumericLogoProps = VariantLogoProps;

const INumericLogo = ({ className, ...rest }: NumericLogoProps) => {
  return (
    <FormatterValidatorLogo Icon={NumericIcon} className={merge('bg-teal-50 text-[#0E9384]', className)} {...rest} />
  );
};

export const NumericLogo = memo(INumericLogo) as typeof INumericLogo;
